import { createModule } from '../../createModule';
export const createMarketSummaryAPI = createModule(({ http }) => {
    return {
        getReturnFrequencies: () => {
            return http.get('/v2/market-summary/return-frequencies');
        },
        getBuckets: () => {
            return http.get('/v2/market-summary/buckets');
        },
        getSubBuckets: () => {
            return http.get('/v2/market-summary/sub-buckets');
        },
        getValueTypes: () => {
            return http.get('/v2/market-summary/value-types');
        },
        getDisplays: () => {
            return http.get('/v2/market-summary/displays');
        },
        listAllInstruments: () => {
            return http.get(`/v2/market-summary/instruments`);
        },
        addInstrument: (params) => {
            return http.post('/v2/market-summary/instruments', {
                body: { ...params, bucket: params.bucket ?? null, sub_bucket: params.sub_bucket ?? null },
            });
        },
        listAllEvents: () => {
            return http.get(`/v2/market-summary/events`);
        },
        createEvent: (params) => {
            return http.post('/v2/market-summary/events', { body: { ...params, ed_dt: params.ed_dt ?? null } });
        },
        removeInstrument: (params) => {
            return http.delete(`/v2/market-summary/instruments/${params.instrument_id}`);
        },
        updateInstrument: ({ instrument_id, ...params }) => {
            return http.patch(`/v2/market-summary/instruments/${instrument_id}`, {
                body: { ...params, bucket: params.bucket ?? null, sub_bucket: params.sub_bucket ?? null },
            });
        },
        deleteEvent: (params) => {
            return http.delete(`/v2/market-summary/events/${params.event_id}`);
        },
        display: (display_id) => {
            return {
                getReport: (params) => {
                    return http.get(`/v2/market-summary/display/${display_id}/report`, { params });
                },
                exportAsEmail: (params) => {
                    return http.post(`/v2/market-summary/display/${display_id}/report/email`, {
                        body: { report_date: params.report_date },
                    });
                },
                instruments: {
                    listAll: () => http.get(`/v2/market-summary/display/${display_id}/instruments`),
                    add: (params) => {
                        return http.post(`/v2/market-summary/display/${display_id}/instruments`, {
                            body: { instrument_id: params.instrument_id },
                        });
                    },
                    remove: (params) => {
                        return http.delete(`/v2/market-summary/display/${display_id}/instruments/${params.instrument_id}`);
                    },
                },
                metrics: {
                    listAll: () => {
                        return http.get(`/v2/market-summary/display/${display_id}/metrics`);
                    },
                    add: (params) => {
                        return http.post(`/v2/market-summary/display/${display_id}/metrics`, {
                            body: {
                                ...params,
                                display_id,
                                return_frequency: params.return_frequency ?? null,
                                event_id: params.event_id ?? null,
                            },
                        });
                    },
                    remove: (params) => {
                        return http.delete(`/v2/market-summary/display/${display_id}/metrics/${params.display_metric_id}`);
                    },
                    updateDisplayOrder: (params) => {
                        return http.post(`/v2/market-summary/display/${display_id}/metrics/display-order`, { body: params });
                    },
                },
            };
        },
    };
});
